import { useSessionContext } from "./SessionProvider";

export function useSession() {
  // Clean and simple - useSessionContext never throws
  return useSessionContext();
}
